import axios from '@_system/axios/axios.js'
export default {
	path: '/saleorder',
	list(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	save(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	get(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.get(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	update(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.put(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	delete(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.delete(this.path + '/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},
	init(data = {}) {
		return new Promise((resolve,reject) => {
			axios.get('moduleConfig/admin/saleorder.saleorder', data, (res) => {
				resolve(res.data)
			},reject,true)
		})
	},
	wlnorder(id, data = {}) {
		return new Promise((resolve, reject) => {
			axios.post(this.path + '/wlnorder/' + id, data, (res) => {
				resolve(res.data)
			}, reject)
		})
	},
	listTrades(id, data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/listTrades/' + id, data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	getDelivery(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/getDelivery', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	push(data = {}) {
		return new Promise((resolve,reject) => {
			axios.post(this.path + '/push', data, (res) => {
				resolve(res.data)
			},reject)
		})
	},	
	import(data = {}) {
		return new Promise((resolve) => {
			axios.post(this.path + '/import', data, (res) => {
				resolve(res.data)
			})
		})
	},
	// saleorderimport(id, data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderimport/' + id, data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
	// saleorderexport(data = {}) {
	// 	return new Promise((resolve) => {
	// 		axios.post(this.path + '/saleorderexport', data, (res) => {
	// 			resolve(res.data)
	// 		})
	// 	})
	// },
}
